<div>
    <div class="modal-header d-flex justify-content-center"
        [ngClass]="modalType == 'error' ? 'error' : modalType == 'warning' ? 'warning' : 'success'">
        <h4 class="modal-title  text-center">{{'DELETE_USER_TITLE_TEXT' | translate}}</h4>
    </div>
    <div class="modal-body text-center">
        {{'DELETE_USER_CONFIRM_TEXT' | translate}}
        <div class="form-group">
          <div class="p-bottom-10">
            <label>{{'DELETE_USER_REASON_TEXT' | translate}}:</label>
          </div>
            <textarea class="form-control" rows="3" #deleteJustification
            [attr.maxLength]="maxReasonLength" (input)="currentLength = deleteJustification.value.length"></textarea>
            <div class="text-end small mt-1"
              [ngClass]="{'text-danger': currentLength > maxReasonLength}">
              {{currentLength}} / {{maxReasonLength}}
            </div>
            <div class="error-msg text-align" *ngIf="displayErrorMsgBlock">
                {{'DELETE_REASON_EMPTY_ERROR' | translate}}
            </div>
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-primary btn-block primary-btn" style="margin-bottom : 10px;" (click)="confirmUserDelete()">{{'DELETE_USER_TEXT'
            | translate}}</button>
        <button class="btn btn-primary cta-blue info-btn" style="margin-bottom : 10px;" (click)="cancelUserDelete()">{{'CANCEL' |
            translate}}</button>
    </div>
</div>